import axios from 'axios';
import { productFiltersSchema } from '../schemas/product-filters';
import { validate } from '../validate';
import { CREATOR_API } from '../creator-api';

async function get() {
  const { data } = await axios.get(CREATOR_API.config.endpoints.productFilters);
  const errors = [];

  const validated = {
    filters: {
      departments: validate(
        data.filters.departments,
        productFiltersSchema,
        errors
      ),
      categories: validate(
        data.filters.categories,
        productFiltersSchema,
        errors
      )
    }
  };

  return { data: validated, errors };
}

export default { get };
